const Americaon2022_2 = [
    {
        "type":"Contig",
        "MAX":"14878522",
        "N10":"10332549",
        "N20":"7739720",
        "N30":"6487735",
        "N40":"5049845",
        "N50":"3942398",
        "N60":"3159562",
        "N70":"2403826",
        "N80":"1635561",
        "N90":"798053",
        "MIN":"50"
    },
    {
        "type":"Scaffold",
        "MAX":"208914723",
        "N10":"208914723",
        "N20":"208914723",
        "N30":"108402862",
        "N40":"108402862",
        "N50":"107056366",
        "N60":"88780741",
        "N70":"84797853",
        "N80":"66557409",
        "N90":"57878935",
        "MIN":"4509638"
    }
]
let Americaon2022_2Colums=[]
Object.keys(Americaon2022_2[0]).map(key=>{
    Americaon2022_2Colums.push({
        title:key.split("_").join(" "),
        key:key,
        align:"center",
        dataIndex:key
    })
})
export {Americaon2022_2,Americaon2022_2Colums}